import React from 'react';
import { GatsbyBrowser } from 'gatsby';
import { WidgetProvider } from '@bitcoin-portal/mpc-widget';
import Layout from './src/components/Layout';

export const onClientEntry = () => {
  const script = document.createElement('script');
  script.src =
    'https://platform.illow.io/banner.js?siteId=25438428-b0e5-41a5-b873-b234ae0ad2db';
  script.async = true;
  document.head.appendChild(script);
};

export const wrapPageElement: GatsbyBrowser['wrapPageElement'] = ({
  element,
}) => {
  return (
    <WidgetProvider
      baseUrl={process.env.WIDGET_BASE_URL || ''}
      redirectUrl={process.env.WIDGET_REDIRECT_URL || ''}
      stytchPublicToken={process.env.STYTCH_PUBLIC_TOKEN || ''}
    >
      <Layout>{element}</Layout>
    </WidgetProvider>
  );
};
